import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Parse from '../parseConfig';
import { userHasBuiltHomeAccessRole } from './built/builtHomeAccess';

const RequireBuiltHomeRoleRoute = ({ component: Component, ...rest }) => {
  const currentUser = Parse.User.current();
  const location = useLocation();
  const [accessState, setAccessState] = useState(currentUser ? 'checking' : 'signed-out');

  useEffect(() => {
    let isCancelled = false;

    if (!currentUser) {
      setAccessState('signed-out');
      return () => { isCancelled = true; };
    }

    setAccessState('checking');
    userHasBuiltHomeAccessRole(currentUser)
      .then((hasAccess) => {
        if (!isCancelled) setAccessState(hasAccess ? 'allowed' : 'denied');
      })
      .catch((error) => {
        console.error('Failed to verify Built Home role membership:', error);
        if (!isCancelled) setAccessState('denied');
      });

    return () => { isCancelled = true; };
  }, [currentUser]);

  if (!currentUser || accessState === 'signed-out') {
    const redirectTo = `${location.pathname}${location.search}`;
    sessionStorage.setItem('redirectTo', redirectTo);
    return <Navigate to="/" replace />;
  }

  if (accessState === 'checking') {
    return null;
  }

  if (accessState === 'denied') {
    return <Navigate to="/main" replace />;
  }

  return <Component {...rest} />;
};

export default RequireBuiltHomeRoleRoute;
